// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1PLvI","notes":"Notes_notes__2Rd_n","note":"Notes_note__1qnfJ","markdown":"Notes_markdown__12a6H"};